import { useEffect } from "react";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import DonationSection from "@/components/DonationSection";
import Footer from "@/components/Footer";

const Index = () => {
  useEffect(() => {
    const title = "NeuroResearch Foundation - Investigación en Enfermedades Neurológicas";
    const description = "Fundación dedicada a la investigación de enfermedades neurológicas: Dolor Crónico, Alzheimer, Parkinson y ELA. Dona para investigar tratamientos innovadores. Apoyamos a asociaciones de pacientes en Europa, entre ellas, las enfermedades raras en España y Portugal. Estaremos encantados de dar cabida a la investigación del sistema ECS y Neuro conectores.";
    
    document.title = title;
    
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:locale"]', 'content', 'es_ES');
    updateMeta('meta[property="og:type"]', 'content', 'website');
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <AboutSection />
      <DonationSection />
      <Footer />
    </div>
  );
};

export default Index;
